import { d as l, k as c } from "../../../util-b2b0dc25.js";
import { isDef as o } from "../../../assets/utils/shared.js";
let d = 0;
class r {
  constructor(t, e, i) {
    this.data = t, this.config = e, this.parent = i || null, this.level = this.parent ? this.parent.level + 1 : 1, this.uid = d++, this.initState(), this.initChildren();
  }
  initState() {
    const { value: t, label: e } = this.config;
    this.value = this.data[t], this.label = this.data[e], this.pathNodes = this.calculatePathNodes(), this.path = this.pathNodes.map((i) => i.value), this.pathLabels = this.pathNodes.map((i) => i.label), this.loading = !1, this.loaded = !1;
  }
  initChildren() {
    const { config: t } = this, e = t.children, i = this.data[e];
    this.hasChildren = Array.isArray(i), this.children = (i || []).map(
      (s) => new r(s, t, this)
    );
  }
  get isDisabled() {
    const { data: t, parent: e, config: i } = this, s = i.disabled, { checkStrictly: a } = i;
    return t[s] || !a && e && e.isDisabled;
  }
  get isLeaf() {
    const { data: t, loaded: e, hasChildren: i, children: s } = this, { lazy: a, leaf: h } = this.config;
    if (a) {
      const n = o(t[h]) ? t[h] : e ? !s.length : !1;
      return this.hasChildren = !n, n;
    }
    return !i;
  }
  calculatePathNodes() {
    const t = [this];
    let e = this.parent;
    for (; e; )
      t.unshift(e), e = e.parent;
    return t;
  }
  getPath() {
    return this.path;
  }
  getValue() {
    return this.value;
  }
  getValueByOption() {
    return this.config.emitPath ? this.getPath() : this.getValue();
  }
  getText(t, e) {
    return t ? this.pathLabels.join(e) : this.label;
  }
  isSameNode(t) {
    const e = this.getValueByOption();
    return this.config.multiple && Array.isArray(t) ? t.some((i) => l(i, e)) : l(t, e);
  }
  broadcast(t, ...e) {
    const i = `onParent${c(t)}`;
    this.children.forEach((s) => {
      s && (s.broadcast(t, ...e), s[i] && s[i](...e));
    });
  }
  emit(t, ...e) {
    const { parent: i } = this, s = `onChild${c(t)}`;
    i && (i[s] && i[s](...e), i.emit(t, ...e));
  }
  onParentCheck(t) {
    this.isDisabled || this.setCheckState(t);
  }
  onChildCheck() {
    const { children: t } = this, e = t.filter((s) => !s.isDisabled), i = e.length ? e.every((s) => s.checked) : !1;
    this.setCheckState(i);
  }
  setCheckState(t) {
    const e = this.children.length, i = this.children.reduce((s, a) => {
      const h = a.checked ? 1 : a.indeterminate ? 0.5 : 0;
      return s + h;
    }, 0);
    this.checked = t, this.indeterminate = i !== e && i > 0;
  }
  syncCheckState(t) {
    const e = this.getValueByOption(), i = this.isSameNode(t, e);
    this.doCheck(i);
  }
  doCheck(t) {
    this.checked !== t && (this.config.checkStrictly ? this.checked = t : (this.broadcast("check", t), this.setCheckState(t), this.emit("check")));
  }
}
export {
  r as default
};
